import { useContext, useState } from 'react';

import CloseTwoToneIcon from '@mui/icons-material/CloseTwoTone';
import MenuTwoToneIcon from '@mui/icons-material/MenuTwoTone';
import { LoadingButton } from '@mui/lab';
import {
  Box,
  Divider,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  alpha,
  lighten,
  styled,
  useTheme
} from '@mui/material';
import { useParams } from 'react-router';
import AlertDialog from 'src/components/AlertDialog';
import { SidebarContext } from 'src/contexts/SidebarContext';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux';
import { submitQuestionnaireAns } from 'src/store/questionnaire/questionnaireService';

const HeaderWrapper = styled(Box)(
  ({ theme }) => `
        height: ${theme.header.height};
        color: ${theme.header.textColor};
        padding: ${theme.spacing(0, 2)};
        right: 0;
        z-index: 6;
        background-color: ${alpha(theme.header.background!, 0.95)};
        backdrop-filter: blur(3px);
        position: fixed;
        justify-content: space-between;
        width: 100%;
        @media (min-width: ${theme.breakpoints.values.lg}px) {
            left: ${theme.sidebar.width};
            width: auto;
        }
`
);

function Header() {
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  const { status, questionnaires, docs_to_upload, isAuthenticated } = useAppSelector((state) => state.applications)
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const params = useParams();
  const [confirmSubmission, setConfirmSubmission] = useState({ state: false, asDraft: false });


  return (<>
    {confirmSubmission.state && <AlertDialog
      alert_type='info'
      state={status}
      title='CONFIRM ACTION'
      onProceed={() => {
        setConfirmSubmission({ state: false, asDraft: false });
        dispatch(submitQuestionnaireAns({ clientId: params.client_id!, questionnaires, isDraft: false, files: docs_to_upload }))
      }}
      onClose={() => setConfirmSubmission({ state: false, asDraft: false })}
      body={<Typography>Are you sure you want to submit?</Typography>}
      open={confirmSubmission.state}
    />}
    <HeaderWrapper
      display="flex"
      alignItems="center"
      sx={{
        boxShadow:
          theme.palette.mode === 'dark'
            ? `0 1px 0 ${alpha(
              lighten(theme.colors.primary.main, 0.7),
              0.15
            )}, 0px 2px 8px -3px rgba(0, 0, 0, 0.2), 0px 5px 22px -4px rgba(0, 0, 0, .1)`
            : `0px 2px 8px -3px ${alpha(
              theme.colors.alpha.black[100],
              0.2
            )}, 0px 5px 22px -4px ${alpha(
              theme.colors.alpha.black[100],
              0.1
            )}`
      }}
    >
      <Stack
        direction="row"
        divider={<Divider orientation="vertical" flexItem />}
        alignItems="center"
        spacing={2}
      >
        {/* <HeaderMenu /> */}
      </Stack>
      <Box display="flex" alignItems="center">
        {/* <HeaderButtons /> */}
        <LoadingButton
          loading={isAuthenticated === null || status === 'pending'}
          style={{ marginRight: '20px' }}
          onClick={() => {
            setConfirmSubmission({ state: true, asDraft: false });
          }}
          disabled={isAuthenticated === null || status === 'pending'}
          variant="contained">Submit Form
        </LoadingButton>
        <Box
          component="span"
          sx={{
            ml: 2,
            display: { lg: 'none', xs: 'inline-block' }
          }}
        >
          <Tooltip arrow title="Toggle Menu">
            <IconButton color="primary" onClick={toggleSidebar}>
              {!sidebarToggle ? (
                <MenuTwoToneIcon fontSize="small" />
              ) : (
                <CloseTwoToneIcon fontSize="small" />
              )}
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
    </HeaderWrapper>
  </>
  );
}

export default Header;
